module.exports = __webpack_public_path__ + "media/applicants/device_signup_8-6b9a3f0c.jpg";